import { z } from 'zod';

import { BaseWidgetSchema } from './BaseWidgetSchema';
import { WidgetType } from '../../utils/widgetsUtils';
import { ContentAreaLayout } from '../../utils/yjsUtils/types/ContentAreaLayout';

export const ContentAreaWidgetStaticSchema = BaseWidgetSchema(WidgetType.ContentArea).extend({
  layout: z.nativeEnum(ContentAreaLayout),
  size: z.number(),
  style: z.record(z.unknown())
});

export type ContentAreaWidgetStaticSchemaType = z.infer<typeof ContentAreaWidgetStaticSchema>;
